/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const ingestSubtitlesBodySchema = z.object({
  vaultUrl: z.string().url(),
});

export type IIngestSubtitlesBody = z.infer<typeof ingestSubtitlesBodySchema>;
